import { useCallback, useMemo } from 'react';
import { ConversationMessageDraft, useDeleteConversationMessageDraft } from 'src/graphql';

export const useConversationDraftActions = () => {
  const { deleteAllConversationMessageDrafts, deleteConversationMessageDraft } =
    useDeleteConversationMessageDraft();

  const discardAll = useCallback(() => {
    void deleteAllConversationMessageDrafts();
  }, [deleteAllConversationMessageDrafts]);

  const discardOne = useCallback(
    (draft: ConversationMessageDraft) => {
      void deleteConversationMessageDraft(draft, {
        clearLocalDrafts: Boolean(draft.userId),
      });
    },
    [deleteConversationMessageDraft],
  );

  const actionsMenuItems = useMemo(() => {
    return [
      {
        icon: 'trash-2',
        iconLibrary: 'lucide' as const,
        label: 'Discard All',
        danger: true,
        onClick: discardAll,
      },
    ];
  }, [discardAll]);

  return {
    discardAll,
    discardOne,
    actionsMenuItems,
  };
};
